import React from 'react';
import { Box, Copy, H6, Optional } from '@honda-canada/design-system-react';
import PaymentCalculatorTooltipAnchor from '../../PaymentCalculator/shared/PaymentCalculatorTooltipAnchor';
import themeStyles from './PriceBreakdownModalContent.styles';
import { getBreakdownGroupContentValue } from './usePriceBreakdownGroups';
import { useLanguage } from '../../../utils/sitecoreContext';
import InlineTextAndTooltip from '../../../utils/components/InlineTextTooltip';
const SectionGroupHeading = themeStyles.apply(Box, 'SectionGroupHeading');
const SectionGroupTitle = themeStyles.apply(H6, 'SectionGroupTitle');
const FloatingSectionGroupTitle = themeStyles.apply(H6, 'FloatingSectionGroupTitle');
const StyledTooltip = themeStyles.apply(PaymentCalculatorTooltipAnchor, 'StyledTooltip');
const DescriptionCopy = themeStyles.apply(Copy, 'SubSectionGroupItemTitle');
const processTitle = (text) => {
    if (text === null || text === void 0 ? void 0 : text.includes(';')) {
        const titleArr = text.split(';');
        return titleArr[0];
    }
    return text;
};
const processContent = (text, titleValue) => {
    if (titleValue === null || titleValue === void 0 ? void 0 : titleValue.includes(';')) {
        const contentArr = titleValue.split(';');
        return contentArr[1];
    }
    return text;
};
const BreakdownGroupTitle = ({ title, description, descriptionTestId, tooltipText, unit, value, margin, padding, asAccordion, dataTestId, }) => {
    var _a;
    const language = useLanguage();
    const labelTitle = (_a = processTitle(title)) !== null && _a !== void 0 ? _a : '';
    return (React.createElement(SectionGroupHeading, { "data-testid": `${dataTestId}-wrapper`, margin, padding, rightPadding: !asAccordion ? '45px' : undefined },
        React.createElement(SectionGroupTitle, null,
            React.createElement(Box, null,
                React.createElement(Box, { "data-testid": `${dataTestId}-title` },
                    React.createElement(InlineTextAndTooltip, { text: labelTitle },
                        React.createElement(Optional, { when: tooltipText },
                            React.createElement(StyledTooltip, { contentWidth: 320 }, tooltipText)))),
                React.createElement(Optional, { when: description },
                    React.createElement(Box, { "data-testid": descriptionTestId },
                        React.createElement(DescriptionCopy, { style: { marginTop: 8 } }, description))))),
        React.createElement(Optional, { when: description },
            React.createElement(FloatingSectionGroupTitle, { "data-testid": `${dataTestId}-value` }, processContent(getBreakdownGroupContentValue(value, unit, language), title))),
        React.createElement(Optional, { when: !description },
            React.createElement(SectionGroupTitle, { isValue: true, "data-testid": `${dataTestId}-value` }, processContent(getBreakdownGroupContentValue(value, unit, language), title)))));
};
export default BreakdownGroupTitle;
